var module = angular.module('octopusApp.infrastructure');

module.factory('octoUploader', function($q, $filter, FileUploader, sniffer) {

  function create($scope) {
    var uploader = new FileUploader({
        scope: $scope,
        withCredentials: true,
        headers: {'Accept': '*/*'}
    });
    var octoUpload = {
      uploader: uploader,
      begin: begin,
      selectedFile: '',
      cancel: cancel
    };

   uploader.onSuccessItem = function (item, response, status, headers) {
      if (sniffer.isIE9) {
        response = JSON.parse(response.replace('<pre>', '').replace('</pre>', ''));
      }
      if (response.ErrorMessage) {
        item.uploadPromise.reject(response);
        return;
      }
      item.uploadPromise.resolve(response);
    };

    uploader.onErrorItem = function (item, response, status, headers) {
      item.uploadPromise.reject(response);
    };

    uploader.onAfterAddingFile = function(a){
      octoUpload.selectedFile = a.file.name + ' ('+ $filter('bytesToSize')(a.file.size) +')';
    };

    function cancel(){
      uploader.clearQueue();
      octoUpload.selectedFile = '';
    }

    function begin(uploadUrl) {
        if(uploader.queue === 0){
            return;
        }

      var uploadPromise = $q.defer();

      uploader.onBeforeUploadItem = function (item) {
        delete uploader.onBeforeUploadItem;
        item.uploadPromise = uploadPromise;

        if (item._xhr) {
          item._xhr.withCredentials = true;
        }
          item.withCredentials = true;
          item.url = uploadUrl;
      };

      uploader.uploadItem(uploader.queue[uploader.queue.length-1]);
      return uploadPromise.promise;
    }

    return octoUpload;
  }

  return {
    create: create
  };
});




//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/services/octo_uploader.js
// module id = 698
// module chunks = 1